// extracted by mini-css-extract-plugin
export default {"root":"rss_page___root___b76b07c7","actions":"rss_page___actions___b70c9487"};